/** Required only if all items in the list are required also */
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function equalValidator(formControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlValue = control.value as string;
    let forbidden = false;

    if (!!formControl.value && formControl.value !== '' && controlValue !== formControl.value) {
      forbidden = true;
    }

    return forbidden ? {equal: {value: control.value}} : null;
  };
}